import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { CalendarDays, Phone, User } from "lucide-react";
import { toast } from "sonner";

const STATUS = {
  richiesta: { label: "Da confermare", cls: "bg-amber-500/15 text-amber-300" },
  confermata: { label: "Confermata", cls: "bg-[#00E676]/15 text-[#00E676]" },
  rifiutata: { label: "Rifiutata", cls: "bg-zinc-600/30 text-zinc-400" },
  annullata: { label: "Annullata dal cliente", cls: "bg-red-500/15 text-red-400" },
  completata: { label: "Completata", cls: "bg-sky-500/15 text-sky-300" },
};

export default function ProBookings() {
  const [items, setItems] = useState([]);
  const load = async () => { try { const { data } = await api.get("/professional/bookings"); setItems(data); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } };
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);
  const act = async (id, action) => { try { await api.put(`/professional/bookings/${id}`, { action }); load(); toast.success("Aggiornato"); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } };

  return (
    <div className="space-y-3 max-w-2xl">
      <div className="text-sm text-zinc-400 flex items-center gap-2"><CalendarDays className="h-4 w-4 text-[#00E676]" /> Le prenotazioni dei clienti sui tuoi slot di disponibilità.</div>
      {items.length === 0 && <div data-testid="bookings-empty" className="text-zinc-500 py-10 text-center">Nessuna prenotazione ricevuta.</div>}
      {items.map((b) => (
        <div key={b.id} data-testid={`booking-${b.id}`} className="bg-[#1C1C1F] border border-white/10 rounded-xl p-4">
          <div className="flex items-center justify-between gap-2">
            <span className="font-semibold flex items-center gap-2"><CalendarDays className="h-4 w-4 text-[#00E676]" /> {b.date} · {b.start}</span>
            <span className={`text-[10px] rounded-full px-2 py-0.5 ${STATUS[b.status]?.cls}`}>{STATUS[b.status]?.label || b.status}</span>
          </div>
          <div className="text-sm text-zinc-300 mt-1.5 flex items-center gap-2"><User className="h-3.5 w-3.5" /> {b.customer_name}{b.customer_phone && <span className="text-zinc-400 flex items-center gap-1"><Phone className="h-3.5 w-3.5" /> {b.customer_phone}</span>}</div>
          {b.note && <p className="text-sm text-zinc-400 mt-1">{b.note}</p>}
          <div className="flex gap-2 mt-3 flex-wrap">
            {b.status === "richiesta" && <>
              <Button size="sm" data-testid={`booking-confirm-${b.id}`} onClick={() => act(b.id, "confirm")} className="bg-[#00E676] text-black font-semibold">Conferma</Button>
              <Button size="sm" variant="destructive" data-testid={`booking-reject-${b.id}`} onClick={() => act(b.id, "reject")}>Rifiuta</Button>
            </>}
            {b.status === "confermata" && <Button size="sm" data-testid={`booking-complete-${b.id}`} onClick={() => act(b.id, "complete")} className="bg-white/10">Segna completata</Button>}
          </div>
        </div>
      ))}
    </div>
  );
}
